<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md d-none">
                <div class="col-lg-6">
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href=""
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" rel="noopener" href=""
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                    <a target="_blank" rel="noopener" href=""
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    <a target="_blank" rel="noopener" href=""
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-github"></i>
                    </a>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; 2020 - {{year}}
                        <a href="/" target="_blank" rel="noopener">CADFlo </a>
                         / <a href="http://www.floefd-cadflo.ru/" target="_blank" rel="noopener">Старая версия</a>
                         <br>
                         Разработка сайта - <a href="https://tevale.ru" target="_blank">tevale</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <a href="/" class="nav-link" rel="noopener">Главная</a>
                        </li>
                        <li class="nav-item">
                            <a href="/products/" class="nav-link" rel="noopener">Продукты</a>
                        </li>
                        <li class="nav-item">
                            <a href="/solutions/" class="nav-link" rel="noopener">Решения</a>
                        </li>
                        <li class="nav-item">
                            <a href="http://my.cadflo.com/"
                               class="nav-link" rel="noopener" target="_blank">Техподдержка</a>
                        </li>
                    </ul>
                    <br>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        name: 'app-footer',
        data() {
            return {
                year: new Date().getFullYear()
            }
        }
    };
</script>
<style>

</style>
